module.exports = __webpack_public_path__ + "img/MultiLineText.dd404fc9.svg";